import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import { Link } from "react-router-dom";

export default function CookieConsent() {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      // Small delay so it doesn't flash on page load
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie-consent", "accepted");
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookie-consent", "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-2 sm:p-3 animate-in slide-in-from-bottom-4 duration-500">
      <div className="mx-auto max-w-xl rounded-lg border bg-card/95 backdrop-blur-md px-4 py-2.5 shadow-elevated flex items-center gap-3">
        <p className="flex-1 text-xs text-muted-foreground leading-snug">
          {t("cookie.message")}{" "}
          <Link to="/privacy" className="underline text-secondary hover:text-secondary/80">
            {t("cookie.privacyPolicy")}
          </Link>
        </p>
        <div className="flex gap-2 shrink-0">
          <Button variant="ghost" size="sm" className="h-7 text-xs px-3" onClick={handleDecline}>
            {t("cookie.decline")}
          </Button>
          <Button size="sm" className="h-7 text-xs px-3 bg-secondary text-secondary-foreground hover:bg-secondary/90" onClick={handleAccept}>
            {t("cookie.accept")}
          </Button>
        </div>
      </div>
    </div>
  );
}
